export default function getSanitizedContextParams(requestParams) {
  // all context parameters with allowed values.
  const params = {
    _application: {
      defaultValue: 'SITE',
      allowed: ['SITE', 'ASSOCIATE', 'MOBILE', 'MEW', 'SEO_LINK_MODULE', 'SEARCH_AND_SEND', 'MSA'],
    },
    _navigationType: {
      defaultValue: 'BROWSE',
      allowed: ['SEARCH', 'BROWSE', 'LANDING'],
    },
    _shoppingMode: {
      defaultValue: 'SITE',
      allowed: ['SITE', 'WEDDING_REGISTRY', 'STORE'],
    },
    _memberShip: {
      defaultValue: undefined,
      allowed: ['NON_MEMBER', 'THIRD_PARTY', 'BASE_CREDITCARD', 'TOP_OF_THE_LIST', 'ALL_MEMBERS'],
    },
    _additionalStoreLocations: {
      defaultValue: undefined,
      allowed: ['SEARCH', 'BROWSE', 'LANDING'],
    },
    _customerExperiment: undefined,
    _userId: undefined,
    _sessionId: undefined,
    _storeLocation: undefined,
  };

  // get context parameters from request; validate parameters with allowed values, and construct new request params.
  const contextParams = {};
  // append parameters
  Object.keys(params).forEach((param) => {
    /* istanbul ignore else */
    if (params[param] && params[param].defaultValue) {
      contextParams[param] = params[param].defaultValue;
    }
    /* istanbul ignore else */
    if (requestParams[param]) {
      /* istanbul ignore else */
      if (!params[param].allowed || params[param].allowed.indexOf(requestParams[param]) > -1) {
        contextParams[param] = requestParams[param];
      }
    }
  });

  return contextParams;
}
